const PriceTable = data => {
  const table = document.createElement('table');
  const { academicLevels, deadlines } = data;

  const th1 = document.createElement('th');
  const th2 = document.createElement('th');
  const tr = document.createElement('tr');

  table.classList.add('pricing-table');

  tr.classList.add('pricing-table__headers');

  th1.classList.add('pricing-table__deadline-header');
  th1.setAttribute('rowspan', '2');
  th1.innerText = 'Deadline';

  th2.classList.add('pricing-table__academic-levels-header');
  th2.setAttribute('colspan', academicLevels.length);
  th2.innerText = 'Academic level';

  tr.appendChild(th1);
  tr.appendChild(th2);

  const tableLevelsRow = () => {
    const t = document.createElement('tr');
    t.classList.add('pricing-table__academic-levels-titles');

    academicLevels.forEach(level => {
      const tableTd = document.createElement('td');
      tableTd.innerText = level.title;

      t.appendChild(tableTd);
    });

    return t;
  };

  const tableDeadlines = () => {
    const deadlineCleanClass = () => {
      table.classList.remove('hovered');
      const allHoveredNodes = table.querySelectorAll('.hovered');
      allHoveredNodes.forEach(el => el.classList.remove('hovered'));
    };

    const deadlineAddClass = e => {
      const hoveredTd = e.target;
      const hoveredTr = hoveredTd.parentNode;
      const deadlinesHeaders = [
        ...table.querySelector('.pricing-table__academic-levels-titles').children,
      ];

      table.classList.add('hovered');

      if (hoveredTd.classList.contains('hovered')) {
        hoveredTd.removeEventListener('mouseout', deadlineCleanClass);
      } else {
        hoveredTr.classList.add('hovered');
        [].slice.call(deadlinesHeaders).forEach((i, index) => {
          if (index + 1 === +hoveredTd.dataset.deadlineId && !i.classList.contains('hovered')) {
            i.classList.add('hovered');
          }
        });

        const deadlinesNodes = document.querySelectorAll(
          `[data-deadline-id="${hoveredTd.dataset.deadlineId}"]`,
        );
        [].slice.call(deadlinesNodes).forEach(el => el.classList.add('hovered'));
        hoveredTd.addEventListener('mouseout', deadlineCleanClass);
      }
    };

    const out = [];
    Object.entries(deadlines).forEach(([deadlineName, value]) => {
      const t = document.createElement('tr');
      const th = document.createElement('th');

      th.classList.add('pricing-table__deadline-name');
      th.innerHTML = `${deadlineName === '1 month' ? `${deadlineName}*` : deadlineName}`;
      t.classList.add('pricing-table__row');
      t.appendChild(th);

      academicLevels.forEach(level => {
        const tableTd = document.createElement('td');
        tableTd.setAttribute('data-deadline-id', level.id);
        if (academicLevels[0].id === level.id) tableTd.classList.add('deadline-active');
        tableTd.innerHTML = value[level.id]
          ? `<span>$</span>${Math.round(value[level.id].pricePerPage)}`
          : 'n/a';

        t.appendChild(tableTd);

        if (window.innerWidth > 768) tableTd.addEventListener('mouseenter', deadlineAddClass);
      });

      out.push(t);
    });

    return out;
  };

  table.appendChild(tr);
  table.appendChild(tableLevelsRow());
  [...tableDeadlines()].forEach(d => table.appendChild(d));

  return new Promise((resolve, reject) => {
    if (data) resolve(table);
    reject(Error('Error data'));
  });
};

export default PriceTable;
